import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  ButtonComponent,
  DialogRefService,
  InputComponent,
  SelectComponent,
} from '@group24ag/flowkit';

@Component({
  selector: 'app-dialog-confirm-delete',
  imports: [
    ButtonComponent,
    ReactiveFormsModule,
    InputComponent,
    SelectComponent,
  ],
  template: `
    <div class="flex flex-col gap-4">
      <ng-template #reasonSelectedTpl let-item="item">{{ item }}</ng-template>
      <ng-template #reasonOptionTpl let-option="option">
        {{ option }}
      </ng-template>

      <p class="text-sm">
        You are about to permanently delete
        <span class="font-semibold">{{ data.itemName }}</span
        >. This action cannot be undone.
      </p>

      <flk-select
        label="Reason"
        placeholder="Select a reason"
        [options]="reasons"
        [selectedTemplate]="reasonSelectedTpl"
        [optionTemplate]="reasonOptionTpl"
        [formControl]="reasonControl" />

      <flk-input
        label="Additional note"
        placeholder="Optional — add context for the audit log"
        [formControl]="noteControl" />

      <div class="flex justify-between gap-2 pt-2">
        <button
          flkButton
          [appearance]="'secondary'"
          [variant]="'default'"
          (click)="onCancel()">
          Cancel
        </button>
        <button
          flkButton
          [variant]="'warn'"
          [disabled]="reasonControl.invalid"
          (click)="onConfirm()">
          Delete
        </button>
      </div>
    </div>
  `,
})
export class DialogConfirmDeleteComponent {
  /** PROPERTIES **/
  /** Payload passed via DialogConfig.data */
  protected readonly data = this.dialogRef.data as { itemName: string };

  protected readonly reasons = [
    'No longer needed',
    'Created by mistake',
    'Superseded by another item',
    'Other',
  ];

  protected readonly reasonControl = new FormControl<string | null>(
    null,
    Validators.required
  );
  protected readonly noteControl = new FormControl('');

  constructor(
    private readonly dialogRef: DialogRefService<DialogConfirmDeleteComponent>
  ) {}

  protected onCancel(): void {
    this.dialogRef.close(null);
  }

  protected onConfirm(): void {
    this.dialogRef.close({
      confirmed: true,
      reason: this.reasonControl.value,
      note: this.noteControl.value || null,
    });
  }
}
